<dynamic-form-v2 
    *ngIf="!isLoading" 
    entityType="qa-user-groups" 
    [formName]="qaUserGroup" 
    [(record)]="qaUserGroupRecord"
    [fields]="fields"
    [viewRoute]="viewRoute"
>
</dynamic-form-v2>